export default function () {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
    >
      <rect
        width="16"
        height="16"
        transform="translate(0.25 0.5)"
        fill="white"
      />
      <rect x="1.25" y="1.5" width="6.5" height="6.5" fill="#F35325" />
      <rect x="8.75" y="1.5" width="6.5" height="6.5" fill="#81BC06" />
      <rect x="1.25" y="9" width="6.5" height="6.5" fill="#05A6F0" />
      <rect x="8.75" y="9" width="6.5" height="6.5" fill="#FFBA08" />
    </svg>
  );
}
